import { useCallback, useMemo } from 'react';

import { ModalIds } from '../../../../contexts/modals/modals.types';
import { useModalsContext } from '../../../../contexts';
import { useTranslation } from 'react-i18next';

/**
 * useSecuritySettingsChangeErrorData hook.
 * @description The hook which processes SecuritySettingsChangeError modal data.
 *
 * @author Oleksii Medvediev
 * @category Hooks
 */
const useSecuritySettingsChangeErrorData = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });
  const {
    data: { securitySettingsChangeError },
    dispatch,
  } = useModalsContext();

  const handleCloseModal = useCallback(
    () => dispatch({ type: 'HIDE_MODAL', payload: ModalIds.securitySettingsChangeError }),
    [dispatch],
  );

  return {
    t,
    type: useMemo(() => securitySettingsChangeError?.type, [securitySettingsChangeError]),
    handleCloseModal,
  };
};

export { useSecuritySettingsChangeErrorData };
